import React, {useEffect, useState} from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import Chart from 'react-apexcharts';
import 'react-datepicker/dist/react-datepicker.css';
import ApiUtils from 'api/ApiUtils';

const GuestListByVenue = (): any => {
  // const [startDate, setStartDate] = useState(new Date());
  // const selectedYear = moment(startDate).format('YYYY');
  const [cardData, setCardData]: any = useState([]);
  // console.log('🚀 ~ GuestListByVenue ~ cardData:', cardData);

  // const [activeChart, setActiveChart] = useState<string>('');
  // const inputRef: any = useRef(null);
  // const inputRefByYear: any = useRef(null);

  const fetchDasboardData = async (): Promise<void> => {
    const resp: any = await ApiUtils.getGuestListEngagement();
    setCardData(resp?.data);
  };

  useEffect(() => {
    void fetchDasboardData();
  }, []);

  const venues: any[] = [];
  const series = [
    {
      name: 'Guests count',
      data: cardData?.map((data: any) => {
        venues.push(data?.name);
        return data?.guestlist_count;
      }),
    },
  ];

  const options: any = {
    chart: {
      height: 400,
      // type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Guest list by venue`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },

    xaxis: {
      categories: venues,
    },
  };

  return (
    <Col xxl={12} className="order-last">
      <Card>
        <Card.Header className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1 text-start">
            Guests List By Venue
          </h4>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xxl={12}>
              <Chart
                options={options}
                series={series}
                type="line"
                height="405"
                className="apex-charts"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default GuestListByVenue;
